import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
export class BeforeUnload {
    static init() {
        if (!this._initialized) {
            this._initialized = true;
            // Wire up before unload
            this._originalBeforeUnload = window.onbeforeunload;
            window.onbeforeunload = window["__onbeforeunload"] = (ev)=>{
                return this.handleBeforeUnload(ev);
            };
        }
    }
    static registerHandler(callback) {
        const registration = {
            callback,
            isRegistered: true
        };
        this._handlers.push(registration);
        return ()=>{
            if (!registration.isRegistered) {
                return;
            }
            registration.isRegistered = false;
            const registrationIndex = this._handlers.indexOf(registration);
            if (registrationIndex >= 0) {
                this._handlers.splice(registrationIndex, 1);
            }
        };
    }
    static handleBeforeUnload(ev) {
        let response;
        for (const registration of [
            ...this._handlers
        ]){
            if (!registration.isRegistered) {
                continue;
            }
            try {
                response = registration.callback(true);
                if (response) {
                    break;
                }
            } catch (e) {
                throw new Error(ErrorUtilities.getMessage(e));
            }
        }
        if (!response && this._originalBeforeUnload) {
            try {
                response = this._originalBeforeUnload(ev);
            } catch (e) {
                throw new Error(ErrorUtilities.getMessage(e));
            }
        }
        // Make sure the response is undefined so ie will not block
        return response ? response : undefined;
    }
}
BeforeUnload._handlers = [];
BeforeUnload._initialized = false;
